var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPhandshakeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65560",
    "data-name": "Grupo 65560",
    transform: "translate(-1104 -988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15501",
    "data-name": "Ret\\xE2ngulo 15501",
    transform: "translate(1104 988)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65548",
    "data-name": "Grupo 65548",
    transform: "translate(4323 7149.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95114",
    "data-name": "Caminho 95114",
    d: "M213.19,246.5h-2.25a2.584,2.584,0,0,1-1.72-.78,4.151,4.151,0,0,0-5.77.13L200,249.26a2.828,2.828,0,0,0,4,4l2.5-2.51a.934.934,0,0,0,.2-1.017.915.915,0,0,0-.2-.3.932.932,0,0,0-1.32,0l-2.5,2.5a.955.955,0,0,1-.3.2.948.948,0,0,1-.72,0,.955.955,0,0,1-.3-.2,1,1,0,0,1,0-1.33l3.41-3.41a2.309,2.309,0,0,1,3.24-.09,4.452,4.452,0,0,0,3,1.28h2.25a.936.936,0,0,1,.658.272.945.945,0,0,1,.2.3.927.927,0,0,1,.071.356v5.63a.941.941,0,0,1-.93.94h-2.72a2.842,2.842,0,0,0-.59-3.11l-.71-.71a.94.94,0,0,0-1.33,0,1,1,0,0,0,0,1.33l.71.71a.913.913,0,0,1,.206.3.922.922,0,0,1-.206,1.019l-.73.73-3.25,3.25a.942.942,0,0,1-1.32,0l-2.15-2.15a4.663,4.663,0,0,0-3.32-1.38h-3a.93.93,0,0,1-.93-.93v-5.63a.941.941,0,0,1,.93-.94h1.25a4.492,4.492,0,0,0,3-1.18,2.551,2.551,0,0,1,1.76-.69.94.94,0,1,0,0-1.88,4.455,4.455,0,0,0-3,1.19,2.572,2.572,0,0,1-1.76.69h-1.25a2.81,2.81,0,0,0-2.84,2.81v5.63a2.81,2.81,0,0,0,2.81,2.81h3a2.8,2.8,0,0,1,2,.82l2.15,2.15a2.8,2.8,0,0,0,4,0l3-3h4.32a2.81,2.81,0,0,0,2.72-2.78v-5.63a2.81,2.81,0,0,0-2.81-2.81Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95115",
    "data-name": "Caminho 95115",
    d: "M201,240.3a.938.938,0,0,0-1.2-.57,1,1,0,0,0-.56,1.21l.64,1.76a.94.94,0,0,0,1.76-.64Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95116",
    "data-name": "Caminho 95116",
    d: "M208.17,239.73a.938.938,0,0,0-1.2.57l-.64,1.76a.939.939,0,0,0,.914,1.335.937.937,0,0,0,.671-.35.94.94,0,0,0,.175-.345l.64-1.76a.942.942,0,0,0-.028-.722.951.951,0,0,0-.218-.3A.93.93,0,0,0,208.17,239.73Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95117",
    "data-name": "Caminho 95117",
    d: "M204,239a.939.939,0,0,0-.94.94v1.87a.94.94,0,0,0,1.88,0v-1.87A.939.939,0,0,0,204,239Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPhandshakeicon);
export default __webpack_public_path__ + "static/media/LPhandshakeicon.8b7247c8267261818e8743acb475eab0.svg";
export { ForwardRef as ReactComponent };